import { render } from "./FilesModal.vue?vue&type=template&id=a8fdfaea&scoped=true&ts=true"
import script from "./FilesModal.vue?vue&type=script&lang=ts"
export * from "./FilesModal.vue?vue&type=script&lang=ts"

import "./FilesModal.vue?vue&type=style&index=0&id=a8fdfaea&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fdfaea"]])

export default __exports__